var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"ImageUrl") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <span class=\"city\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"City") : depth0), depth0))
    + "</span>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <span class=\"title\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"Title") : depth0), depth0))
    + "</span>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <span class=\"duration\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"Duration") : depth0), depth0))
    + "</span>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"listItemWrapper\">\r\n    <div class=\"listItem\">\r\n        <div class=\"imageContainer\">\r\n            <div class=\"image\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"ImageUrl") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":16},"end":{"line":7,"column":23}}})) != null ? stack1 : "")
    + "            </div>\r\n        </div>\r\n        <div class=\"contentContainer\">\r\n            <div class=\"content\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"City") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":16},"end":{"line":14,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"Title") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":16},"end":{"line":17,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"Duration") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":16},"end":{"line":20,"column":23}}})) != null ? stack1 : "")
    + "\r\n                <a class=\"more\" href=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"Url") : depth0), depth0))
    + "\" title=\"Lees meer over "
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"Title") : depth0), depth0))
    + "\">\r\n                    <span>Meer informatie</span>\r\n                    <svg viewBox=\"0 0 100 72\" style=\"height: 12.96px;\"><path d=\"M99.69,35A7.78,7.78,0,0,0,97,28.37L70.45,1.78a7.93,7.93,0,0,0-11,.94,7.93,7.93,0,0,0,.94,11.15L75.06,28.55H7.93a7.9,7.9,0,1,0,0,15.79H73.8L60.41,57.73A7.92,7.92,0,1,0,70.63,69.82L97.22,43.23A7.91,7.91,0,0,0,99.69,35Z\"></path></svg>\r\n                </a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>";
},"useData":true});